import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA } from '@angular/material';


import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
//import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-search-accts',
  templateUrl: './search-accts.component.html',
  styleUrls: ['./search-accts.component.css']
})
export class SearchAcctsComponent implements OnInit {
  acctTypes = [];
  mainAccts = [];
  model = {'acct_type_id':'', 'sub_acct_name':'', 'main_acct_id':'', 'acct_number':''};
  private dp = [];
  displayedColumns = ['acct_number', 'sub_acct_name', 'action'];
  dataSource = new MatTableDataSource(this.dp);
  
  @ViewChild(MatSort) sort: MatSort;

  constructor(private utils: Utils,	private applicationConstants: ApplicationConstants,	private queryList: QueryList, 
              private dialogRef: MatDialogRef<SearchAcctsComponent>, @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
   
    this.acctTypes = [{acct_type_id:0, acct_type_name: 'اختر ...'}, {acct_type_id:1, acct_type_name: 'العملاء'},
                      {acct_type_id:2, acct_type_name: 'الموردين'}, {acct_type_id:3, acct_type_name: 'البنك'},
                      {acct_type_id:4, acct_type_name: 'الحسابات'}];
   /* let query = this.queryList.all_acct_types;
    let obj = {cmd: 'getList', query:query};

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.acctTypes = data.data['list'];
      });*/
  }

  getMainAcct() {
    //console.log(this.model['acct_type_id']);
    if(this.model['acct_type_id'] != '4')
      return;

    let query =  "SELECT * FROM `main_acct` WHERE `status` = '1' ";// AND `acct_type_id` = " + 
      //this.model['acct_type_id']; 
    let obj = {cmd: 'getList', query:query};
    // console.log(query);

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.mainAccts = data.data['list'];
        //console.log(this.acctTypes);
        
      });
  }

  search() {
    //console.log(this.model);
    this.dp = [];
    let acct_type_id = this.model['acct_type_id'];
    if(acct_type_id =='')
    {
        alert('الرجاء اختيار نوع الحساب');
        return;
    }
    let table = '';
    let where = " WHERE `status` = '1'";
    if(acct_type_id =='1')
    {
      table = ' `customer` ';
      if(this.model['sub_acct_name'] !='')
        where += " AND `customer_name` LIKE '%" + this.model['sub_acct_name']+"%'";
      if(this.model['acct_number'] !='')
        where += " AND `customer_no` LIKE '%" + this.model['acct_number']+"%'";
    }
    else if(acct_type_id =='2')
    {  
      table = ' `supplier` ';
      if(this.model['sub_acct_name'] !='')
        where += " AND `supplier_name` LIKE '%" + this.model['sub_acct_name']+"%'";
      if(this.model['acct_number'] !='')
        where += " AND `supplier_no` LIKE '%" + this.model['acct_number']+"%'";
    }
    else if(acct_type_id =='3')
    {
      table = ' `bank_account` ';
      if(this.model['sub_acct_name'] !='')
        where += " AND `account_name` LIKE '%" + this.model['sub_acct_name']+"%'";
      if(this.model['acct_number'] !='')
        where += " AND `account_number` LIKE '%" + this.model['acct_number']+"%'";
    }  
    else if(acct_type_id =='4')
    {
      table = ' `sub_acct` ';
      if(this.model['sub_acct_name'] !='')
        where += " AND `sub_acct`.`sub_acct_name` LIKE '%" + this.model['sub_acct_name']+"%'";
      //if(this.model['main_acct_id'] !='')
        //where += " AND `sub_acct`.`main_acct_id` = " + this.model['main_acct_id'];
      //if(this.model['acct_type_id'] !='')
        //where += " AND `sub_acct`.`acct_type_id` = " + this.model['acct_type_id'];
      if(this.model['acct_number'] !='')
        where += " AND `sub_acct`.`acct_number` LIKE '%" + this.model['acct_number']+"%'";
    }
    //  console.log(table);

    let query = "SELECT * FROM " + table + where;
    let obj = {cmd: 'getList', query:query};
    //console.log(obj);

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        //console.log(acct_type_id);
        //if(acct_type_id == '4')
        this.dp = data.data['list'];
        let n = '';
        let no = '';
        let n_e = '';
        let a_id = '';
        let a_type = ''
        if(acct_type_id =='1')
        {
          n = 'customer_name';
          no = 'customer_no';
          n_e = 'customer_name_en';
          a_id = 'customer_id';
          a_type = 'customer';
        }
        else if(acct_type_id =='2')
        {
          n = 'supplier_name';
          no = 'supplier_no';
          n_e = 'supplier_name_en';
          a_id = 'supplier_id';
          a_type = 'supplier';
        }
        else if(acct_type_id =='3')
        {
          n = 'account_name';
          no = 'acct_number';
          n_e = 'account_name_en';
          a_id = 'account_id';
          a_type = 'bank';
        }
        else if(acct_type_id =='4')
        {
          a_type = 'account';
        }
        if(acct_type_id != '4')
        {
          for(let v of this.dp)
          {
            v['sub_acct_name'] = v[n];
            v['acct_number'] = v[no];
            v['sub_acct_name_en'] = v[n_e];
            v['sub_acct_id'] = v[a_id];
            v['account_type'] = a_type; // acct_type_id;// v[a_id];
          }
        }
        else // if type is account (4)
        {
          for(let v of this.dp)
          {
            v['account_type'] = a_type;
          }
        }
        //console.log(this.dp);
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
        
      });
  }

  select(acct) {
    this.dialogRef.close(acct);
  }

}
